import { Box, FormControl, Paper, Select } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledSelectContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'fullWidth',
})<{ fullWidth: boolean }>(({ fullWidth }) => ({
  display: 'inline-flex',
  flexDirection: 'column',
  position: 'relative',
  minWidth: '0px',
  padding: '0px',
  margin: '0px',
  border: '0px',
  verticalAlign: 'top',
  width: fullWidth ? '100%' : 'auto',
}));

export const StyledFormControl = styled(FormControl)(() => ({}));

export const StyledSelect = styled(Select)(({ theme, value, size }) => ({
  color: theme.palette.custom.black[90],
  lineHeight: '100%',
  backgroundColor: 'white',

  ...(size !== 'small' && {
    height: '52px',

    '& .MuiOutlinedInput-input': {
      padding: '14.5px 14px',
    },
  }),

  '& .MuiSelect-select': {
    minHeight: '0 !important',
  },
  '& .MuiOutlinedInput-input': {
    borderTopRightRadius: '14px',
    borderBottomRightRadius: '14px',
  },

  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.custom.black[!value ? 10 : 90],
    borderRadius: '14px',
  },

  '& .MuiInputBase-input::placeholder': {
    color: theme.palette.custom.black[30],
    opacity: 1,
  },

  '&:hover:not(.Mui-disabled)': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.custom.black[30],
    },
  },

  '&.Mui-error': {
    color: theme.palette.error.main,

    '& .MuiInputBase-input::placeholder': {
      color: theme.palette.error.main,
    },
  },

  '& .Mui-disabled': {
    backgroundColor: theme.palette.custom.grey3,
    borderColor: theme.palette.custom.black[20],
  },
}));

export const StyledSelectPaper = styled(Paper)`
  border: 2px solid #e1e1e2;

  border-radius: 7px;

  > ul {
    padding: 0 !important;
  }
`;
